import React, { Dispatch } from "react";
import { fetchApi } from "../../../../../config/core/Api";
import { AxiosResponse } from "axios";

interface ImagePaginationProps {
  paginationConfig: any;
  setIsLoading: Dispatch<boolean>;
  errorFunc: any;
}

function ImagePagination({
  paginationConfig: pc,
  setIsLoading,
  errorFunc,
}: ImagePaginationProps): JSX.Element {
  function fetchData(action: "previous" | "next") {
    fetchApi({
      fullUrl: action == "previous" ? pc.previous : pc.next,
      method: "GET",
    })
      .then((r: AxiosResponse<any>) => {
        if (r.status == 200) {
          pc.editParentState(r.data);
          if (r.data.paging) {
            pc.editSelfState({
              ...pc,
              next: r.data.paging.next ? r.data.paging.next : null,
              previous: r.data.paging.previous ? r.data.paging.previous : null,
            });
          }
        } else {
          errorFunc();
        }
      })
      .catch((e) => {
        errorFunc();
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  let t = window.INITIAL_DATA.TRANSLATIONS;
  return (
    <div className={"d-flex justify-content-center w-100 mb-2"}>
      <div className={"position-relative d-flex mt-3"}>
        <div className={"d-flex align-items-center mr-2"}>
          <button
            type={"button"}
            disabled={!pc.previous}
            onClick={() => fetchData("previous")}
            className={"btn btn-dark facebook-uploads__btn back mr-2"}></button>
          <p className={"text-sm m-0 d-none d-md-block"}>{t.prev}</p>
        </div>

        <div className={"d-flex align-items-center ml-2"}>
          <p className={"text-sm m-0 d-none d-md-block"}>{t.next}</p>
          <button
            type={"button"}
            disabled={!pc.next}
            onClick={() => fetchData("next")}
            className={
              "btn btn-dark facebook-uploads__btn forward ml-2"
            }></button>
        </div>
      </div>
    </div>
  );
}

export default ImagePagination;
